import { PayloadAction } from '@reduxjs/toolkit';
import { DesignState } from 'src/store/design/types';

const setDesignOriginalQuantityReducer = (state: DesignState, action: PayloadAction<number|undefined>) => {
  state.originalQuantity = action.payload;
};

export default setDesignOriginalQuantityReducer;
